module.exports = __webpack_public_path__ + "img/logo.ad6d8564.png";